import __var_0__ from '@stdlib/utils/define-read-only-property';
import __var_1__ from '@stdlib/regexp/basename';
import __var_2__ from '@stdlib/regexp/basename-posix';
import __var_3__ from '@stdlib/regexp/basename-windows';
import __var_4__ from '@stdlib/regexp/color-hexadecimal';
import __var_5__ from '@stdlib/regexp/decimal-number';
import __var_6__ from '@stdlib/regexp/dirname';
import __var_7__ from '@stdlib/regexp/dirname-posix';
import __var_8__ from '@stdlib/regexp/dirname-windows';
import __var_9__ from '@stdlib/regexp/eol';
import __var_10__ from '@stdlib/regexp/extended-length-path';
import __var_11__ from '@stdlib/regexp/extname';
import __var_12__ from '@stdlib/regexp/extname-posix';
import __var_13__ from '@stdlib/regexp/extname-windows';
import __var_14__ from '@stdlib/regexp/filename';
import __var_15__ from '@stdlib/regexp/filename-posix';
import __var_16__ from '@stdlib/regexp/filename-windows';
import __var_17__ from '@stdlib/regexp/function-name';
import __var_18__ from '@stdlib/regexp/native-function';
import __var_19__ from '@stdlib/regexp/regexp';
import __var_20__ from '@stdlib/regexp/unc-path';
import __var_21__ from '@stdlib/regexp/utf16-surrogate-pair';
import __var_22__ from '@stdlib/regexp/utf16-unpaired-surrogate';
import __var_23__ from '@stdlib/regexp/whitespace';
/**

*
* Copyright (c) 2018 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

'use strict';

/*
* When adding modules to the namespace, ensure that they are added in alphabetical order according to module name.
*/

// MODULES //
var setReadOnly = __var_0__;


// MAIN //

/**
* Top-level namespace.
*
* @namespace regexp
*/
var regexp = {};

/**
* @name RE_BASENAME
* @memberof regexp
* @readonly
* @constant
* @type {RegExp}
* @see {@link module:@stdlib/regexp/basename}
*/
setReadOnly( regexp, 'RE_BASENAME', __var_1__);

/**
* @name RE_BASENAME_POSIX
* @memberof regexp
* @readonly
* @constant
* @type {RegExp}
* @see {@link module:@stdlib/regexp/basename-posix}
*/
setReadOnly( regexp, 'RE_BASENAME_POSIX', __var_2__);

/**
* @name RE_BASENAME_WINDOWS
* @memberof regexp
* @readonly
* @constant
* @type {RegExp}
* @see {@link module:@stdlib/regexp/basename-windows}
*/
setReadOnly( regexp, 'RE_BASENAME_WINDOWS', __var_3__);

/**
* @name RE_COLOR_HEXADECIMAL
* @memberof regexp
* @readonly
* @constant
* @type {RegExp}
* @see {@link module:@stdlib/regexp/color-hexadecimal}
*/
setReadOnly( regexp, 'RE_COLOR_HEXADECIMAL', __var_4__);

/**
* @name RE_DECIMAL_NUMBER
* @memberof regexp
* @readonly
* @constant
* @type {RegExp}
* @see {@link module:@stdlib/regexp/decimal-number}
*/
setReadOnly( regexp, 'RE_DECIMAL_NUMBER', __var_5__);

/**
* @name RE_DIRNAME
* @memberof regexp
* @readonly
* @constant
* @type {RegExp}
* @see {@link module:@stdlib/regexp/dirname}
*/
setReadOnly( regexp, 'RE_DIRNAME', __var_6__);

/**
* @name RE_DIRNAME_POSIX
* @memberof regexp
* @readonly
* @constant
* @type {RegExp}
* @see {@link module:@stdlib/regexp/dirname-posix}
*/
setReadOnly( regexp, 'RE_DIRNAME_POSIX', __var_7__);

/**
* @name RE_DIRNAME_WINDOWS
* @memberof regexp
* @readonly
* @constant
* @type {RegExp}
* @see {@link module:@stdlib/regexp/dirname-windows}
*/
setReadOnly( regexp, 'RE_DIRNAME_WINDOWS', __var_8__);

/**
* @name RE_EOL
* @memberof regexp
* @readonly
* @constant
* @type {RegExp}
* @see {@link module:@stdlib/regexp/eol}
*/
setReadOnly( regexp, 'RE_EOL', __var_9__);

/**
* @name RE_EXTENDED_LENGTH_PATH
* @memberof regexp
* @readonly
* @constant
* @type {RegExp}
* @see {@link module:@stdlib/regexp/extended-length-path}
*/
setReadOnly( regexp, 'RE_EXTENDED_LENGTH_PATH', __var_10__);

/**
* @name RE_EXTNAME
* @memberof regexp
* @readonly
* @constant
* @type {RegExp}
* @see {@link module:@stdlib/regexp/extname}
*/
setReadOnly( regexp, 'RE_EXTNAME', __var_11__);

/**
* @name RE_EXTNAME_POSIX
* @memberof regexp
* @readonly
* @constant
* @type {RegExp}
* @see {@link module:@stdlib/regexp/extname-posix}
*/
setReadOnly( regexp, 'RE_EXTNAME_POSIX', __var_12__);

/**
* @name RE_EXTNAME_WINDOWS
* @memberof regexp
* @readonly
* @constant
* @type {RegExp}
* @see {@link module:@stdlib/regexp/extname-windows}
*/
setReadOnly( regexp, 'RE_EXTNAME_WINDOWS', __var_13__);

/**
* @name RE_FILENAME
* @memberof regexp
* @readonly
* @constant
* @type {RegExp}
* @see {@link module:@stdlib/regexp/filename}
*/
setReadOnly( regexp, 'RE_FILENAME', __var_14__);

/**
* @name RE_FILENAME_POSIX
* @memberof regexp
* @readonly
* @constant
* @type {RegExp}
* @see {@link module:@stdlib/regexp/filename-posix}
*/
setReadOnly( regexp, 'RE_FILENAME_POSIX', __var_15__);

/**
* @name RE_FILENAME_WINDOWS
* @memberof regexp
* @readonly
* @constant
* @type {RegExp}
* @see {@link module:@stdlib/regexp/filename-windows}
*/
setReadOnly( regexp, 'RE_FILENAME_WINDOWS', __var_16__);

/**
* @name RE_FUNCTION_NAME
* @memberof regexp
* @readonly
* @constant
* @type {RegExp}
* @see {@link module:@stdlib/regexp/function-name}
*/
setReadOnly( regexp, 'RE_FUNCTION_NAME', __var_17__);

/**
* @name RE_NATIVE_FUNCTION
* @memberof regexp
* @readonly
* @constant
* @type {RegExp}
* @see {@link module:@stdlib/regexp/native-function}
*/
setReadOnly( regexp, 'RE_NATIVE_FUNCTION', __var_18__);

/**
* @name RE_REGEXP
* @memberof regexp
* @readonly
* @constant
* @type {RegExp}
* @see {@link module:@stdlib/regexp/regexp}
*/
setReadOnly( regexp, 'RE_REGEXP', __var_19__);

/**
* @name RE_UNC_PATH
* @memberof regexp
* @readonly
* @constant
* @type {RegExp}
* @see {@link module:@stdlib/regexp/unc-path}
*/
setReadOnly( regexp, 'RE_UNC_PATH', __var_20__);

/**
* @name RE_UTF16_SURROGATE_PAIR
* @memberof regexp
* @readonly
* @constant
* @type {RegExp}
* @see {@link module:@stdlib/regexp/utf16-surrogate-pair}
*/
setReadOnly( regexp, 'RE_UTF16_SURROGATE_PAIR', __var_21__);

/**
* @name RE_UTF16_UNPAIRED_SURROGATE
* @memberof regexp
* @readonly
* @constant
* @type {RegExp}
* @see {@link module:@stdlib/regexp/utf16-unpaired-surrogate}
*/
setReadOnly( regexp, 'RE_UTF16_UNPAIRED_SURROGATE', __var_22__);

/**
* @name RE_WHITESPACE
* @memberof regexp
* @readonly
* @constant
* @type {RegExp}
* @see {@link module:@stdlib/regexp/whitespace}
*/
setReadOnly( regexp, 'RE_WHITESPACE', __var_23__);


// EXPORTS //
export default regexp;

export { __var_1__ as RE_BASENAME, __var_2__ as RE_BASENAME_POSIX, __var_3__ as RE_BASENAME_WINDOWS, __var_4__ as RE_COLOR_HEXADECIMAL, __var_5__ as RE_DECIMAL_NUMBER, __var_6__ as RE_DIRNAME, __var_7__ as RE_DIRNAME_POSIX, __var_8__ as RE_DIRNAME_WINDOWS, __var_9__ as RE_EOL, __var_10__ as RE_EXTENDED_LENGTH_PATH, __var_11__ as RE_EXTNAME, __var_12__ as RE_EXTNAME_POSIX, __var_13__ as RE_EXTNAME_WINDOWS, __var_14__ as RE_FILENAME, __var_15__ as RE_FILENAME_POSIX, __var_16__ as RE_FILENAME_WINDOWS, __var_17__ as RE_FUNCTION_NAME, __var_18__ as RE_NATIVE_FUNCTION, __var_19__ as RE_REGEXP, __var_20__ as RE_UNC_PATH, __var_21__ as RE_UTF16_SURROGATE_PAIR, __var_22__ as RE_UTF16_UNPAIRED_SURROGATE, __var_23__ as RE_WHITESPACE};